import { render, staticRenderFns } from "./AddAuditRecord.vue?vue&type=template&id=c252928e&scoped=true&"
import script from "./AddAuditRecord.vue?vue&type=script&lang=ts&"
export * from "./AddAuditRecord.vue?vue&type=script&lang=ts&"
import style0 from "./AddAuditRecord.vue?vue&type=style&index=0&id=c252928e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252928e",
  null
  
)

export default component.exports